PJQ.models.addressBook = {};

PJQ.models.addressBook.AddressBookViewSettings = PJQ.models.BaseModel.extend({
	endpoint: function () {
		let params = [];
		if (this.options.forCompany) {
			params.push({
				parameter: 'forCompany',
				value: true
			});
		}
		return PJQ.helpers.urlHelpers.generateEndpoint([
			{
				endpoint: 'addressbook'
			},
			{
				endpoint: 'settings'
			}
		], params);
	},
	getSettings: function (view) {
		return _.find(this.attributes.settings, _.bind(function (setting) {
			return setting.view === view;
		}, this));
	},
	hasGroupListColumn: function (view) {
		let setting = this.getSettings(view), columnFound = false;
		_.each(setting.columns, _.bind(function (column) {
			if (column === 'groupListDisplay') {
				columnFound = true;
			}
		}, this));
		return columnFound;
	},
	hasScreeningPackagesColumn: function (view) {
		let setting = this.getSettings(view), columnFound = false;
		_.each(setting.columns, _.bind(function (column) {
			if (column === 'screeningPackages') {
				columnFound = true;
			}
		}, this));
		return columnFound;
	},
	getContactCustomFieldColumns: function (view) {
		let setting = this.getSettings(view), columns = [];
		_.each(setting.columns, _.bind(function (column) {
			if (column.startsWith('contactCustomField_')) {
				columns.push(parseInt(column.substring(column.indexOf('_') + 1)));
			}
		}, this));

		return columns;
	},
	getCompanyCustomFieldColumns: function (view) {
		let setting = this.getSettings(view), columns = [];
		_.each(setting.columns, _.bind(function (column) {
			if (column.startsWith('companyCustomField_')) {
				columns.push(parseInt(column.substring(column.indexOf('_') + 1)));
			}
		}, this));

		return columns;
	}
});

PJQ.models.addressBook.AddressBookAdvancedSearchSettings = PJQ.models.BaseModel.extend({
	endpoint: function () {
		return PJQ.helpers.urlHelpers.generateEndpoint([
			{
				endpoint: 'addressbook'
			},
			{
				endpoint: 'advancedsearch'
			},
			{
				endpoint: 'settings'
			}
		]);
	}
});

PJQ.models.addressBook.ProqualStatistics = PJQ.models.BaseModel.extend({
	endpoint: function () {
		return PJQ.helpers.urlHelpers.generateEndpoint([
			{
				endpoint: 'addressbook'
			},
			{
				endpoint: 'proqual'
			},
			{
				endpoint: 'stats'
			}
		]);
	}
});

PJQ.models.addressBook.ProqualSettings = PJQ.models.BaseModel.extend({
	endpoint: function () {
		return PJQ.helpers.urlHelpers.generateEndpoint([
			{
				endpoint: 'addressbook'
			},
			{
				endpoint: 'proqual'
			},
			{
				endpoint: 'settings'
			}
		]);
	}
});

PJQ.collections.addressBook = {};
PJQ.collections.addressBook.AddressBookViewResults = PJQ.collections.BaseCollection.extend({
	beforeConstruct: function (models, options) {
		switch (options.view) {
			case PJQ.constants.addressBook.view.CONTACT:
			case PJQ.constants.addressBook.view.COMPANY_CONTACT:
			case PJQ.constants.addressBook.view.TRADES_COMPANY_COMPANY_CONTACT:
			case PJQ.constants.addressBook.view.TRADES_CONTACT_CONTACT:
			case PJQ.constants.addressBook.view.TRADES_COMPANY_COMPANY:
			case PJQ.constants.addressBook.view.COMPANY:
				this.model = PJQ.models.contacts.Contact;
				break;
		}
	},
	endpoint: function (urlOptions) {
		let endpointArr = [
			{
				endpoint: 'addressbook'
			},
			{
				endpoint: 'views'
			},
			{
				endpoint: this.options.view
			}
		];

		if (urlOptions && urlOptions.isExport)
			endpointArr.push({endpoint: 'export'});

		return PJQ.helpers.urlHelpers.generateEndpoint(endpointArr);
	},
	parse: function (data) {
		if (this.options.isExport) {
			this.exportURL = data.url;
		}
		else {
			this.totalRows = 0;
			if (data) {
				this.totalRows = data.totalRows;
				return data.rows;
			}
		}
		return null;
	},
	export: function (data, callback) {
		if (typeof callback !== 'function') {
			return;
		}
		new PJQ.ajax.Request({
			endpoint: this.endpoint({
				isExport: true
			}),
			type: 'POST',
			timeout: 600000,
			data: data
		}).post().done(function (response) {
			callback(response);
		}).fail(function () {
			callback(null);
		});
	}
});

PJQ.collections.addressBook.AddressBookSelections = PJQ.collections.BaseCollection.extend({
	endpoint: function () {
		let endpointArr = [
			{
				endpoint: 'addressbook'
			},
			{
				endpoint: 'selection'
			}
		];

		return PJQ.helpers.urlHelpers.generateEndpoint(endpointArr);
	}
});
